"use client";

import { UIButton } from "@/components/ui/button";
import { useDict } from "@/app/[lang]/providers/DictionaryProvider";
import { HomePage } from "../type/type";

export default function Feature({ data }: { data: HomePage | undefined }) {
    const dict = useDict();
    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-0">
            <div className="flex flex-col md:flex-row gap-6 md:gap-20 ">
            <div className="flex flex-1 flex-col h-auto md:h-80 bg-[url('/images/mesh-119.png')] bg-cover gap-4 rounded-3xl p-6 md:p-10">
                    <h2 className="font-bold text-3xl text-primary">{data?.eproc_title || dict.homepage?.eprocurement || "E-Procurement"}</h2>
                    <p className="font-light text-3xl text-primary">{data?.eproc_subtitle || dict.homepage?.eprocurement_subtitle || "MF Procurement Registration"}</p>
                    {data?.eproc_desc
                      ? <div className="text-lg text-secondary" dangerouslySetInnerHTML={{ __html: data.eproc_desc }} />
                      : <span className="text-lg text-secondary">{dict.homepage?.eprocurement_desc || "Facility for registering suppliers and providers of goods, work, consulting and non-consulting services for PT SMF projects"}</span>
                    }
                    <UIButton variant="outline" className="w-fit cursor-pointer border-[#1a197f] text-[#1a197f]" onClick={() => window.location.href = (data?.eproc_button_url || 'https://eproc.smf-indonesia.co.id')}>
                        {data?.eproc_button_text || dict.homepage?.explore_more || "Explore More"}
                    </UIButton>
                </div>
                <div className="flex flex-1 flex-col h-auto md:h-80 bg-[url('/images/mesh-103.png')] bg-cover gap-4 rounded-3xl p-6 md:p-10">
                    <h2 className="font-bold text-3xl text-negatif">{data?.spp_title || dict.homepage?.whistleblowing || "Whistleblowing"}</h2>
                    <p className="font-light text-3xl text-negatif">{data?.spp_subtitle || dict.homepage?.whistleblowing_subtitle || "Violation Reporting System"}</p>
                    {data?.spp_desc
                      ? <div className="text-lg text-negatif" dangerouslySetInnerHTML={{ __html: data.spp_desc }} />
                      : <span className="text-lg text-negatif">{dict.homepage?.whistleblowing_desc || "Facility for registering suppliers and providers of goods, work, consulting and non-consulting services for PT SMF projects"}</span>
                    }
                    <UIButton variant="outline" className="w-fit cursor-pointer" onClick={() => window.location.href = (data?.spp_button_url || 'https://wbs.smf-indonesia.co.id')}>
                        {data?.spp_button_text || dict.homepage?.explore_more || "Explore More"}
                    </UIButton>
                </div>
            </div>
        </div>
    );
}
